<template>
  <div class="a-spacer" :style="mainCssVars"></div>
</template>

<script>
export default {
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.cms.color_background || '#FFFFFF',
        '--spacing': this.cms.spacing || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.a-spacer {
  background: var(--bg-color);
  min-height: var(--spacing);
}
</style>
